import ApiService from '@/common/api.service';

export const DataSourceService = {
    query({indicator, params}) {
        return ApiService.query(`/pad/${indicator}/data-source`, params);
    }
};
